import type { CustomFieldValue } from '../types';

// Types only, no runtime imports: grid col-defs reach this module, and store/User reaches them.

// An unknown flag leaves the field open: the api still enforces the lock, it just does so by skipping quietly.
// A denied write beats the unrestricted override, since the api's gate refuses it for every role.
export const customFieldEditable = (isEditable: boolean | undefined, unrestricted: boolean, denied = false): boolean =>
  !denied && (unrestricted || isEditable !== false);

// The record's own entry wins where it has one: permission-set masking lowers the flag there and never on the definition.
export const recordCustomFieldEditableFlag = (
  customFields: CustomFieldValue[] | undefined,
  definitionId: string,
  definitionFlag?: boolean
): boolean | undefined => customFields?.find((cf) => cf.definition_id === definitionId)?.is_editable ?? definitionFlag;

export const recordCustomFieldEditable = (
  customFields: CustomFieldValue[] | undefined,
  definition: { id: string; is_editable?: boolean },
  unrestricted: boolean,
  denied: boolean
): boolean =>
  customFieldEditable(
    recordCustomFieldEditableFlag(customFields, definition.id, definition.is_editable),
    unrestricted,
    denied
  );
